'use client';
import { useStore } from 'zustand';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { setOpenLocationSelectionModal } from '@/store/modal';
import { userLocationStore } from '@/store/user-location.store';
import { Typography } from '@/components/ui/typography/typography.component';
import { formatLocationLabel } from '@/utils/formatters/location/format-location-label.util';

export function LocationPin() {
  const userLocation = useStore(userLocationStore, (state) => state?.userLocation);

  const locationLabel = formatLocationLabel(userLocation) || 'Adicione um local';

  return (
    <button
      data-testid={DataTestIdEnum.LOCATION_PIN_BUTTON}
      title={locationLabel}
      className="inline-flex self-start items-center gap-2 max-w-full text-green-500 leading-6 font-semibold text-center cursor-pointer pt-2"
      onClick={() => setOpenLocationSelectionModal(true, { locationCallback: () => {} })}
    >
      <FontAwesomeIcon icon={faLocationDot} className="shrink-0" />
      <Typography
        data-testid={DataTestIdEnum.LOCATION_PIN_TITLE}
        className="text-green-500 truncate min-w-0 hover:underline"
      >
        {locationLabel}
      </Typography>
    </button>
  );
}
